import React, { useEffect, useState } from "react";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  ResponsiveContainer,
  ComposedChart,
  AreaChart,
  LineChart,
  Line,
  Area,
  PieChart,
  Tooltip,
  Pie,
  Cell,
  YAxis,
  XAxis,
  BarChart,
  Bar,
  Legend,
  CartesianGrid,
} from "recharts";
import MUIDataTable from "mui-datatables";
import { FaCircleExclamation } from "react-icons/fa6";

// styles
import useStyles from "./styles";

// components
import mock from "./mock";
import Widget from "../../components/Widget";
import PageTitle from "../../components/PageTitle";
import { Typography } from "../../components/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import Table from "./components/Table/Table";
import BigStat from "./components/BigStat/BigStat";
import apiService from "../../core/service/detail";
import { getMethod } from "../../core/service/common.api";
import { postMethod } from "../../core/service/common.api";
import { toast } from "react-toastify";
import Skeleton from "react-skeleton-loader";
const mainChartData = [
  { date: "Oct 9", beleaf: 2, blocksentials: 2 },
  { date: "Oct 10", beleaf: 8, blocksentials: 5 },
  { date: "Oct 11", beleaf: 0, blocksentials: 0 },
  { date: "Oct 12", beleaf: 3, blocksentials: 0 },
  { date: "Oct 13", beleaf: 6, blocksentials: 0 },
  { date: "Oct 14", beleaf: 5, blocksentials: 0 },
  { date: "Oct 15", beleaf: 0, blocksentials: 1 },
];
const PieChartData = [
  { name: "Group A", value: 400, color: "primary" },
  { name: "Group B", value: 300, color: "secondary" },
  { name: "Group C", value: 300, color: "warning" },
  { name: "Group D", value: 200, color: "success" },
];
const data = [
  { day: "Day 1", value: 10 },
  { day: "Day 2", value: 2 },
  { day: "Day 3", value: 9 },
  { day: "Day 4", value: 5 },
  { day: "Day 5", value: 7 },
  { day: "Day 6", value: 3 },
  { day: "Day 7", value: 8 },
];

// const useStyles = makeStyles((theme) => ({
//   card: {
//     padding: theme.spacing(2),
//   },
//   fullHeightBody: {
//     height: "100%",
//   },
//   serverOverviewElement: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//   },
//   serverOverviewElementText: {
//     fontSize: "2rem",
//     fontWeight: 600,
//     marginBottom: theme.spacing(2),
//   },
//   serverOverviewElementChartWrapper: {
//     width: "100%",
//   },
// }));

// const rawData = [
//   { day: "Day 1", value: 5, site: "BLF" },
//   { day: "Day 1", value: 3, site: "BlockSentials" },
//   { day: "Day 2", value: 7, site: "BLF" },
//   { day: "Day 3", value: 4, site: "BLF" },
// ];

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();

  // local
  var [mainChartState, setMainChartState] = useState("monthly");
  var [loginlist, setloginlist] = useState([]);
  var [rawData, setrawData] = useState([]);
  var [beleafData, setbeleafData] = useState();
  var [beleafDatatotal, setbeleafDatatotal] = useState();
  var [pageLoader, setpageLoader] = useState(true);

  useEffect(() => {
    var id = localStorage.getItem("user_token");
    getLoginHistory(id);
    getDashboardCount();
    getBeleafChartData();
  }, []);
  // useEffect(()=>{
  //   toast("its okay")
  // },[0])
  const getLoginHistory = async (id) => {
    try {
      var payload = {
        user: id,
      };
      var data = {
        apiUrl: apiService.get_login_history,
        payload: payload,
      };
      setpageLoader(true);
      var resp = await postMethod(data);
      setpageLoader(false);
      if (resp.status) {
        setloginlist(resp.Message.loginuser);
      }
    } catch (error) {}
  };
  const [contacts, setcontacts] = useState({});
  const [dataofchart, setdataofchart] = useState();
  const [dataofchartblock, setdataofchartblock] = useState();
  const [unsubmitdata, setunsubmitdata] = useState();
  const [MainChartDatas, setMainChartDatas] = useState();
  const getDashboardCount = async (id) => {
    try {
      var data = {
        apiUrl: apiService.getDashboardCount,
      };
      setpageLoader(true);
      var resp = await postMethod(data);
      setpageLoader(false);
      if (resp.status) {
        setcontacts(resp.data);
        const dataofchart = resp.data.lastSixMonthsChart.map((item) => ({
          day: item.month,
          Count: item.blfCount,
        }));
        setdataofchart(dataofchart);
        const dataofchartblock = resp.data.lastSixMonthsChart.map((item) => ({
          day: item.month,
          Count: item.blockSentialsCount,
        }));
        setdataofchartblock(dataofchartblock);
        const transformed = resp.data.sevendayData.map((item) => ({
          date: item.date, // for X-axis
          beleaf: item.beleaf, // for Y-axis (blue)
          blocksentials: item.blocksentials, // for Y-axis (yellow)
        }));

        setMainChartDatas(transformed);
      } else {
        setcontacts({});
      }
    } catch (error) {}
  };
  const getBeleafChartData = async () => {
    try {
      const data = {
        apiUrl: apiService.getBeleafChartData,
      };
      setpageLoader(true);
      const resp = await postMethod(data);
      console.log(resp, "chart");
      setpageLoader(false);
      if (resp.status && resp.data.chartData) {
        const rawData = resp.data.chartData;
        // Aggregate values by day
        const aggregated = rawData.reduce((acc, curr) => {
          const existing = acc.find((d) => d.day === curr.day);
          if (existing) {
            existing.Count += curr.value;
          } else {
            acc.push({ day: curr.day, Count: curr.value });
          }
          return acc;
        }, []);

        setrawData(rawData); // optional: keep raw data
        setbeleafData(aggregated);

        const totalCount = aggregated.reduce(
          (sum, item) => sum + item.Count,
          0,
        );
        setbeleafDatatotal(totalCount);
        setunsubmitdata(resp.data.daycount);
      } else {
        console.warn("No chart data returned");
      }
    } catch (error) {
      console.error("Error fetching Beleaf chart data:", error);
    }
  };

  //  const classes = useStyles();
  // const theme = useTheme();

  // Filter only BLF (Beleaf)

  return (
    <>
      {pageLoader == true ? (
        <>
          <div className="loader">
            {" "}
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          <PageTitle
            title="Dashboard"
            className={classes.dashboard_header}
            // button="Latest Reports"
          />
          <Grid container spacing={4}>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <Widget
                // title="Beleaf Contacts"
                upperTitle
                bodyClass={classes.fullHeightBody}
                className={classes.card}
              >
                <div className="d-flex align-items-center justify-content-between w-100">
                  <b>
                    <h5>Beleaf Contacts</h5>
                  </b>
                  <div className="dsh_exclamation">
                    <FaCircleExclamation />
                    <div className="dsh_details_box">
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Today count</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blfTodayCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft"> Last Month</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blfMonthCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Last week</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blfWeekCount : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="dsh_card_inner_flx">
                    <h5 className="dsh_title">
                      {contacts ? contacts.blfTotalCount : 0}
                    </h5>
                  </div>

                  {!dataofchart ? (
                    <div className="dsh_card_chart_skl">
                      <Skeleton />
                    </div>
                  ) : (
                    <div>
                      {/* <Typography size="xl" weight="medium">
                      {contacts ? contacts.blfTotalCount : 0}
                    </Typography> */}
                      <div
                        className={classes.serverOverviewElementChartWrapper}
                      >
                        <ResponsiveContainer width="90%" height={150}>
                          <ComposedChart data={dataofchart}>
                            <XAxis dataKey="day" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="Count"
                              stroke="#536DFE"
                              strokeWidth={2}
                              fillOpacity={0.25}
                              dot={{ r: 4 }} // shows the small dots
                            />
                          </ComposedChart>
                        </ResponsiveContainer>
                      </div>
                      {/* <LineChart
                width={55}
                height={30}
                data={[
                  { value: 10 },
                  { value: 15 },
                  { value: 10 },
                  { value: 17 },
                  { value: 18 },
                ]}
                margin={{ left: theme.spacing(2) }}
              > */}
                      {/* <Line
                  type="natural"
                  dataKey="value"
                  stroke={theme.palette.success.main}
                  strokeWidth={2}
                  dot={false}
                /> */}
                      {/* </LineChart> */}
                    </div>
                  )}
                </div>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  {/* <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      Today count
                    </Typography>
                    <Typography size="md">
                      {contacts ? contacts.blfTodayCount : 0}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      Last Month
                    </Typography>
                    <Typography size="md">
                      {contacts ? contacts.blfMonthCount : 0}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      last week
                    </Typography>
                    <Typography size="md">
                      {contacts ? contacts.blfWeekCount : 0}
                    </Typography>
                  </Grid> */}
                </Grid>
              </Widget>
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <Widget
                // title="Blocksentinals Contacts"
                upperTitle
                bodyClass={classes.fullHeightBody}
                className={classes.card}
              >
                <div className="d-flex align-items-center justify-content-between w-100">
                  <b>
                    <h5>Blocksentinals Contacts</h5>
                  </b>
                  <div className="dsh_exclamation">
                    <FaCircleExclamation />
                    <div className="dsh_details_box">
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Today count</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blockseninalsTodayCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft"> Last Month</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blockseninalsMonthCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Last week</span>
                        <span className="dsh_dt_rgt">
                          {contacts ? contacts.blockseninalsWeekCount : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  {/* <Typography size="xl" weight="medium"> */}
                  <div className="dsh_card_inner_flx">
                    <h5 className="dsh_title">
                      {contacts ? contacts.blockseninalsTotal : 0}
                    </h5>
                  </div>
                  {/* </Typography> */}
                  {!dataofchartblock ? (
                    <div className="dsh_card_chart_skl">
                      <Skeleton />
                    </div>
                  ) : (
                    <div className={classes.serverOverviewElementChartWrapper}>
                      <ResponsiveContainer width="90%" height={150}>
                        <ComposedChart data={dataofchartblock}>
                          <XAxis dataKey="day" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="Count"
                            stroke="#536DFE"
                            strokeWidth={2}
                            fillOpacity={0.25}
                            dot={{ r: 4 }} // shows the small dots
                          />
                        </ComposedChart>
                      </ResponsiveContainer>
                    </div>
                  )}
                  {/* <LineChart
                width={55}
                height={30}
                data={[
                  { value: 10 },
                  { value: 15 },
                  { value: 10 },
                  { value: 17 },
                  { value: 18 },
                ]}
                margin={{ left: theme.spacing(2) }}
              > */}
                  {/* <Line
                  type="natural"
                  dataKey="value"
                  stroke={theme.palette.success.main}
                  strokeWidth={2}
                  dot={false}
                /> */}
                  {/* </LineChart> */}
                </div>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  {/* <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      Today count
                    </Typography>
                    <Typography size="md">
                      {" "}
                      {contacts ? contacts.blockseninalsTodayCount : 0}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      Last Month
                    </Typography>
                    <Typography size="md">
                      {" "}
                      {contacts ? contacts.blockseninalsMonthCount : 0}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography color="text" colorBrightness="secondary">
                      last week
                    </Typography>
                    <Typography size="md">
                      {" "}
                      {contacts ? contacts.blockseninalsWeekCount : 0}
                    </Typography>
                  </Grid> */}
                </Grid>
              </Widget>
            </Grid>
            {/* <Grid item lg={3} md={8} sm={6} xs={12}> */}
            {/* <Widget
            title="Today Blocksentinals Contacts"
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                <Dot color="warning" />
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  className={classes.legendElementText}
                >
                  Integration
                </Typography>
              </div>
              <div className={classes.legendElement}>
                <Dot color="primary" />
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  className={classes.legendElementText}
                >
                  SDK
                </Typography>
              </div>
            </div>
            <div className={classes.progressSection}>
              <Typography
                size="md"
                color="text"
                colorBrightness="secondary"
                className={classes.progressSectionTitle}
              >
                Integration
              </Typography>
              <LinearProgress
                variant="determinate"
                value={30}
                classes={{ barColorPrimary: classes.progressBar }}
                className={classes.progress}
              />
            </div>
            <div>
              <Typography
                size="md"
                color="text"
                colorBrightness="secondary"
                className={classes.progressSectionTitle}
              >
                SDK
              </Typography>
              <LinearProgress
                variant="determinate"
                value={55}
                classes={{ barColorPrimary: classes.progressBar }}
                className={classes.progress}
              />
            </div>
          </Widget> */}
            {/* </Grid> */}
            {/* <Grid item lg={4} md={8} sm={6} xs={12}>
          <Widget
            title="Unsubmited Beleaf contacts"
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                23,213
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer width="100%" height={150}>
                  <ComposedChart data={data}>
                    <XAxis dataKey="day" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke={theme?.palette?.secondary?.main || "#8884d8"}
                      strokeWidth={2}
                      fillOpacity={0.25}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </div>
            {/* <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                54% / 31°С / 3.3 Ghz
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer height={50} width="99%">
                  <AreaChart data={getRandomData(10)}>
                    <Area
                      type="natural"
                      dataKey="value"
                      stroke={theme.palette.primary.main}
                      fill={theme.palette.primary.light}
                      strokeWidth={2}
                      fillOpacity="0.25"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                57% / 21°С / 3.3 Ghz
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer height={50} width="99%">
                  <AreaChart data={getRandomData(10)}>
                    <Area
                      type="natural"
                      dataKey="value"
                      stroke={theme.palette.warning.main}
                      fill={theme.palette.warning.light}
                      strokeWidth={2}
                      fillOpacity="0.25"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div> */}
            {/* </Widget>
        </Grid> */}
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Widget
                // title="Unsubmitted Beleaf contacts"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
              >
                {" "}
                <div className="d-flex align-items-center justify-content-between w-100">
                  <b>
                    <h5>Unsubmitted Beleaf Contacts</h5>
                  </b>
                  <div className="dsh_exclamation">
                    <FaCircleExclamation />
                    <div className="dsh_details_box">
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Today count</span>
                        <span className="dsh_dt_rgt">
                          {unsubmitdata ? unsubmitdata.todayCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft"> Last Month</span>
                        <span className="dsh_dt_rgt">
                          {unsubmitdata ? unsubmitdata.lastMonthCount : 0}
                        </span>
                      </div>
                      <div className="dsh_details_flx">
                        <span className="dsh_dt_lft">Last week</span>
                        <span className="dsh_dt_rgt">
                          {unsubmitdata ? unsubmitdata.last7DaysCount : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.serverOverviewElement}>
                  <Typography
                    color="textSecondary"
                    size="xl"
                    weight="medium"
                    // className={classes.serverOverviewElementText}
                  >
                    {beleafDatatotal}
                  </Typography>
                  {!beleafData ? (
                    <div className="dsh_card_chart_skl">
                      <Skeleton />
                    </div>
                  ) : (
                    <div className={classes.serverOverviewElementChartWrapper}>
                      <ResponsiveContainer width="100%" height={150}>
                        <ComposedChart data={beleafData}>
                          <XAxis dataKey="day" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="Count"
                            // stroke={theme.palette.dark.main}
                            stroke="#536DFE"
                            strokeWidth={2}
                            fillOpacity={0.25}
                          />
                        </ComposedChart>
                      </ResponsiveContainer>
                    </div>
                  )}
                </div>
              </Widget>
            </Grid>
            {/* <Grid item lg={3} md={4} sm={6} xs={12}>
          <Widget title="Revenue Breakdown" upperTitle className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ResponsiveContainer width="100%" height={144}>
                  <PieChart margin={{ left: theme.spacing(2) }}>
                    <Pie
                      data={PieChartData}
                      innerRadius={45}
                      outerRadius={60}
                      dataKey="value"
                    >
                      {PieChartData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={theme.palette[entry.color].main}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.pieChartLegendWrapper}>
                  {PieChartData.map(({ name, value, color }, index) => (
                    <div key={color} className={classes.legendItemContainer}>
                      <Dot color={color} />
                      <Typography style={{ whiteSpace: "nowrap" }}>
                        &nbsp;{name}&nbsp;
                      </Typography>
                      <Typography color="text" colorBrightness="secondary">
                        &nbsp;{value}
                      </Typography>
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>
          </Widget>
        </Grid> */}
            <Grid item xs={12}>
              <Widget
                bodyClass={classes.mainChartBody}
                header={
                  <div className={classes.mainChartHeader}>
                    <Typography
                      variant="h5"
                      color="text"
                      colorBrightness="secondary"
                    >
                      Last Seven Days Line Chart
                    </Typography>
                  </div>
                }
              >
                {!MainChartDatas ? (
                  <div className="dsh_card_chart_skl">
                    <Skeleton />
                  </div>
                ) : (
                  <ResponsiveContainer
                    className="dashboard_chart_container"
                    width="100%"
                    minWidth={500}
                    height={350}
                  >
                    <ComposedChart
                      data={MainChartDatas}
                      margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
                      onMouseMove={(e) => console.log("Mouse over chart", e)} // ✅ Add here
                    >
                      {/* Add grid lines for clarity */}
                      <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={theme.palette.divider}
                      />

                      {/* X-Axis = Days */}
                      <XAxis
                        dataKey="date"
                        label={{
                          value: "Days",
                          position: "insideBottom",
                          offset: -5,
                          fill: "#000",
                        }}
                        tick={{
                          fill: "#000",
                          fontSize: 14,
                        }}
                        stroke={theme.palette.text.hint + "80"}
                        tickLine={false}
                      />

                      {/* Y-Axis = Count */}
                      <YAxis
                        label={{
                          value: "Count",
                          angle: -90,
                          position: "insideLeft",
                          offset: 10,
                          fill: "#000",
                        }}
                        allowDecimals={false}
                        domain={[0, "auto"]} // <--- Auto scale based on data (0 to 8 in your case)
                        tick={{
                          fill: "#000",
                          fontSize: 14,
                        }}
                        stroke={theme.palette.text.hint + "80"}
                        tickLine={false}
                      />

                      {/* Tooltip + Legend */}
                      <Tooltip
                        formatter={(value, name) => [`${value}`, name]}
                        labelFormatter={(label) => `Date: ${label}`}
                        contentStyle={{
                          backgroundColor: "#ffffff",
                          borderRadius: 8,
                          border: "1px solid #e0e0e0",
                          padding: "10px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          color: "#333333",
                        }}
                        itemStyle={{ color: "#333333", fontSize: 14 }}
                        labelStyle={{
                          fontWeight: "bold",
                          color: "#000000",
                          fontSize: 15,
                        }}
                      />

                      <Legend verticalAlign="top" height={36} />

                      {/* Beleaf Line */}
                      <Line
                        name="Beleaf"
                        type="monotone"
                        dataKey="beleaf"
                        stroke={theme.palette.primary.main}
                        strokeWidth={2}
                        dot={{
                          stroke: theme.palette.primary.dark,
                          strokeWidth: 2,
                          fill: theme.palette.primary.main,
                        }}
                        activeDot={{ r: 6 }} // ✅ This enables tooltip hover
                      />

                      <Line
                        name="BlockSentials"
                        type="monotone"
                        dataKey="blocksentials"
                        stroke={theme.palette.warning.main}
                        strokeWidth={2}
                        dot={{
                          stroke: theme.palette.warning.dark,
                          strokeWidth: 2,
                          fill: theme.palette.warning.main,
                        }}
                        activeDot={{ r: 6 }} // ✅ This enables tooltip hover
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                )}
              </Widget>

              {/* <Widget
            bodyClass={classes.mainChartBody}
            header={
              <div className={classes.mainChartHeader}>
                <Typography
                  variant="h5"
                  color="text"
                  colorBrightness="secondary"
                >
                  Daily Line Chart
                </Typography> */}
              {/* <div className={classes.mainChartHeaderLabels}>
                  <div className={classes.mainChartHeaderLabel}>
                    <Dot color="warning" />
                    <Typography className={classes.mainChartLegentElement}>
                      Tablet
                    </Typography>
                  </div>
                  <div className={classes.mainChartHeaderLabel}>
                    <Dot color="primary" />
                    <Typography className={classes.mainChartLegentElement}>
                      Mobile
                    </Typography>
                  </div>
                  <div className={classes.mainChartHeaderLabel}>
                    <Dot color="primary" />
                    <Typography className={classes.mainChartLegentElement}>
                      Desktop
                    </Typography>
                  </div>
                </div> */}
              {/* <Select
                  value={mainChartState}
                  onChange={(e) => setMainChartState(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect,
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Select> */}
              {/* </div>
            }
          >
            <ResponsiveContainer width="100%" minWidth={500} height={350}>
              <ComposedChart
                margin={{ top: 0, right: -15, left: -15, bottom: 0 }}
                data={mainChartData}
              >
                <YAxis
                  ticks={[0, 2500, 5000, 7500]}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                  stroke={theme.palette.text.hint + "80"}
                  tickLine={false}
                />
                <XAxis
                  tickFormatter={(i) => i + 1}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                  stroke={theme.palette.text.hint + "80"}
                  tickLine={false}
                />
                <Area
                  type="natural"
                  dataKey="desktop"
                  fill={theme.palette.background.light}
                  strokeWidth={0}
                  activeDot={false}
                />
                <Line
                  type="natural"
                  dataKey="mobile"
                  stroke={theme.palette.primary.main}
                  strokeWidth={2}
                  dot={false}
                  activeDot={false}
                />
                <Line
                  type="linear"
                  dataKey="tablet"
                  stroke={theme.palette.warning.main}
                  strokeWidth={2}
                  dot={{
                    stroke: theme.palette.warning.dark,
                    strokeWidth: 2,
                    fill: theme.palette.warning.main,
                  }}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </Widget> */}
            </Grid>
            {/* {mock.bigStat.map((stat) => (
          <Grid item md={4} sm={6} xs={12} key={stat.product}>
            <BigStat {...stat} />
          </Grid>
        ))} */}
            {/* <Grid item xs={12}> */}
            <PageTitle title=" Login History" />

            <Grid item xs={12}>
              <MUIDataTable
                title={"Login History"}
                data={loginlist}
                columns={[
                  {
                    name: "userName",
                    label: "User Name",
                  },
                  {
                    name: "ipAddress",
                    label: "IP Address",
                  },
                  {
                    name: "browser",
                    label: "Browser",
                  },
                  {
                    name: "platform",
                    label: "Platform",
                  },
                  {
                    name: "dateAndTime",
                    label: "Date & Time",
                  },
                ]}
                // options={{
                //   selectableRows: "none",
                // }}
                className="dsh_mui_table"
              />
            </Grid>

            {/* <Widget
            title="Support Requests"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <Table data={mock.table} /> */}
            {/* </Widget> */}
            {/* </Grid> */}
          </Grid>
        </>
      )}
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  var resultArray = [];
  var tablet = getRandomData(31, 3500, 6500, 7500, 1000);
  var desktop = getRandomData(31, 1500, 7500, 7500, 1500);
  var mobile = getRandomData(31, 1500, 7500, 7500, 1500);

  for (let i = 0; i < tablet.length; i++) {
    resultArray.push({
      tablet: tablet[i].value,
      desktop: desktop[i].value,
      mobile: mobile[i].value,
    });
  }

  return resultArray;
}
